import React from 'react';
import { Helmet } from 'react-helmet';
export const PageMeta = (props) => {
    const { title, children } = props;
    return (React.createElement(Helmet, null,
        React.createElement("title", null,
            title,
            title && ' - ',
            "SweetSpot"),
        children));
};
